export const createPrefixer =
    (...prefixes: string[]) =>
    (source: string) =>
        prefixes.concat(source).join('/');
